// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__43Mrt","dark":"Select_dark__PMBXX"};